import React from 'react';
import styled from 'styled-components';
import Burger from './Burger';
import { Link } from 'react-router-dom';

const Nav = styled.nav`
  width: 100%;
  background-color: #212529;
  height: 65px;

  .wrapper {
    max-width: 1300px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    margin: 0 auto;
  }

  .logo {
    padding-left: 10px;
    padding-top: 7px;
    color: #a6b1e1;
    font-size: 40px;
    font-weight: 700;
    .logo-2 {
      color: #dcd6f7;
    }
  }
`;

const Navbar = () => {
  return (
    <Nav>
      <div className='wrapper'>
        <Link to='/'>
          <div className='logo'>
            GEO<span className='logo-2'>QUIZ</span>
          </div>
        </Link>
        <Burger />
      </div>
    </Nav>
  );
};

export default Navbar;
